var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "#1D1D1B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13665 17.3757C8.99989 17.4552 8.8446 17.4972 8.68643 17.4975C8.52827 17.4978 8.37282 17.4564 8.23576 17.3774C8.0987 17.2985 7.98488 17.1848 7.90577 17.0479C7.82666 16.9109 7.78506 16.7555 7.78516 16.5973V7.40308C7.78506 7.24491 7.82666 7.08952 7.90577 6.95256C7.98488 6.8156 8.0987 6.70192 8.23576 6.62298C8.37282 6.54404 8.52827 6.50263 8.68643 6.50293C8.8446 6.50323 8.99989 6.54522 9.13665 6.62468L17.0683 11.2215C17.2049 11.3005 17.3183 11.4141 17.3971 11.5508C17.4759 11.6874 17.5174 11.8424 17.5174 12.0002C17.5174 12.158 17.4759 12.313 17.3971 12.4497C17.3183 12.5863 17.2049 12.6999 17.0683 12.7789L9.13665 17.3757Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.51d6a2e1e90fc5c903c656ee8408c960.svg";
export { ForwardRef as ReactComponent };